import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { toast } from 'sonner';
import { operacionesApi } from '../../../lib/api';

export default function OperacionesConfig({ edificioId }) {
  const [cfg, setCfg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    operacionesApi.getConfig(edificioId)
      .then(r => setCfg(r.data || {}))
      .finally(() => setLoading(false));
  }, [edificioId]);

  const save = async () => {
    setSaving(true);
    try {
      await operacionesApi.upsertConfig(edificioId, {
        max_autorizados_por_unidad: parseInt(cfg.max_autorizados_por_unidad) || 10,
        horas_semanales_default_por_unidad: cfg.horas_semanales_default_por_unidad ? parseFloat(cfg.horas_semanales_default_por_unidad) : null,
        horas_semanales_default_por_persona: cfg.horas_semanales_default_por_persona ? parseFloat(cfg.horas_semanales_default_por_persona) : null,
      });
      toast.success('Configuración guardada');
    } catch (err) { toast.error(err.response?.data?.detail || 'Error'); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="p-8 text-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400 inline" /></div>;

  return (
    <div className="max-w-xl space-y-4">
      <div>
        <h3 className="font-semibold text-slate-900 mb-1">Reglas globales del edificio</h3>
        <p className="text-xs text-slate-500">Estos valores aplican a todas las unidades salvo que tengan un límite específico configurado en la pestaña "Límites".</p>
      </div>

      <div>
        <Label>Máximo de autorizados por unidad</Label>
        <Input type="number" min={1} value={cfg.max_autorizados_por_unidad ?? 10}
          onChange={e => setCfg({ ...cfg, max_autorizados_por_unidad: e.target.value })}
          data-testid="cfg-max-autoriz" />
        <p className="text-[11px] text-slate-500 mt-1">No incluye al master.</p>
      </div>

      <div>
        <Label>Horas semanales default por unidad (opcional)</Label>
        <Input type="number" min={0} step={0.5}
          value={cfg.horas_semanales_default_por_unidad ?? ''}
          placeholder="Sin límite"
          onChange={e => setCfg({ ...cfg, horas_semanales_default_por_unidad: e.target.value })} />
      </div>

      <div>
        <Label>Horas semanales default por persona (opcional)</Label>
        <Input type="number" min={0} step={0.5}
          value={cfg.horas_semanales_default_por_persona ?? ''}
          placeholder="Sin límite"
          onChange={e => setCfg({ ...cfg, horas_semanales_default_por_persona: e.target.value })} />
      </div>

      <Button onClick={save} disabled={saving} data-testid="cfg-save">
        {saving ? <Loader2 className="w-3 h-3 animate-spin" /> : 'Guardar'}
      </Button>
    </div>
  );
}
